export default __webpack_public_path__ + "static/media/Course-Icons2.e1f7f4cd.svg";